<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <template v-for="(contentPart, index) of content" :key="index">
      <div v-if="contentPart.type === ComplexContentType.Text" v-html="contentPart.text"></div>
      <div v-if="contentPart.type === ComplexContentType.Image">
        <figure class="my-4 w-full overflow-hidden rounded-medium lg:my-8 xl:max-w-xl">
          <img class="w-full" :src="contentPart.url" alt="" />
          <figcaption class="mt-1 block w-full text-left text-sm text-gray-500">
            {{ contentPart.subtitle }}
          </figcaption>
        </figure>
      </div>
      <div v-if="contentPart.type === ComplexContentType.IFrame">
        <figure class="my-4 md:my-10 w-full relative">
          <div
            class="w-full aspect-video overflow-hidden rounded-large relative"
            v-html="contentPart.iframe"
          ></div>
          <figcaption class="mt-1 block w-full text-left text-sm text-gray-500">
            {{ contentPart.subtitle }}
          </figcaption>
        </figure>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { ComplexContentType, type ComplexContent } from '../../../models/complex-content'

interface Props {
  content?: ReadonlyArray<ComplexContent>
}
defineProps<Props>()
</script>
